import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { BankDetailsUpdateInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank.details.update.dto';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { TypeInterface } from '@zaoblako/web/core/models/type.interface';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';
import { JurisdictionTypeEnum } from '@zaoblako/shared/modules/client/enums/jurisdiction-type.enum';
import { BankAutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/bank-auto-complete/bank-auto-complete.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  standalone: true,
  selector: 'crm-table-bank-details',
  templateUrl: './table-bank-details.component.html',
  imports: [
    CommonModule,
    CardModule,
    BankAutoCompleteComponent,
    InputTextComponent,
    ButtonModule,
    JoinPipe,
    TableComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableBankDetailsComponent implements OnChanges {
  @Input() public bankDetails: BankDetailsUpdateInterface[] = [];
  @Output() public bankDetailsChange = new EventEmitter<BankDetailsUpdateInterface[]>();

  @Input() public banks: BankFindInterface[] = [];
  @Input() public header = 'Расчетные счета';
  @Input() public jurisdiction: JurisdictionTypeEnum = null;

  @Input() public withCard = true;

  @Input() public errors: any[];
  public typeErrors: TypeInterface;

  @Output() public bankSearch = new EventEmitter<string>();

  public get JurisdictionTypeEnum() {
    return JurisdictionTypeEnum;
  }

  public columns: CrmTableColumn[] = [{ label: 'Название' }, { label: 'Банк' }, { label: 'Расчетный счёт' }, {}];

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.errors?.currentValue) {
      this.typeErrors = typeof this.errors;
    }
    if (changes.jurisdiction?.currentValue) {
      if (
        changes.jurisdiction?.currentValue === JurisdictionTypeEnum.FOREIGN &&
        this.columns.find((column) => column.label === 'Банк')
      ) {
        this.columns = this.columns.filter((column) => column.label !== 'Банк');
      }

      if (
        changes.jurisdiction?.currentValue !== JurisdictionTypeEnum.FOREIGN &&
        !this.columns.find((column) => column.label === 'Банк')
      ) {
        this.columns.splice(1, 0, { label: 'Банк' });
        this.columns = [...this.columns];
      }
    }
  }

  public toBankDetail(bankDetail: any): BankDetailsUpdateInterface {
    return bankDetail as BankDetailsUpdateInterface;
  }

  public addBankDetail() {
    if (!this.bankDetails) {
      this.bankDetails = [];
    }
    this.bankDetails.push(<BankDetailsUpdateInterface>{});
    this.bankDetails = [...this.bankDetails];
    this.bankDetailsChange.emit(this.bankDetails);
  }

  public deleteBankDetail(bankDetail: BankDetailsUpdateInterface) {
    this.bankDetails = this.bankDetails.filter((_bankDetail) => _bankDetail != bankDetail);
    this.bankDetailsChange.emit(this.bankDetails);
  }
}
